import { render, staticRenderFns } from "./InvoiceItemRow.vue?vue&type=template&id=4316c4c0&"
import script from "./InvoiceItemRow.vue?vue&type=script&lang=js&"
export * from "./InvoiceItemRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports